var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEncontramosComprador(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.167 28c5.833 0 10.5 4.667 10.5 10.5 0 2.053-.584 3.99-1.61 5.6l7.186 7.233L49 54.577l-7.28-7.164A10.493 10.493 0 0136.167 49c-5.834 0-10.5-4.667-10.5-10.5S30.333 28 36.167 28zm0 4.667a5.833 5.833 0 100 11.667 5.833 5.833 0 000-11.667zM23.333 9.333a9.333 9.333 0 019.334 9.334c0 2.123-.724 4.083-1.914 5.67a14.825 14.825 0 00-5.296 3.43L23.333 28a9.333 9.333 0 110-18.667zM4.667 46.667V42c0-4.947 7.723-9.007 17.5-9.333A15.307 15.307 0 0021 38.5c0 3.01.887 5.833 2.333 8.167H4.667z",
    fill: "#54DCF2"
  })));
}
export default SvgIconEncontramosComprador;